import React from 'react';

class Home extends React.Component {
  render() {
    return (

      <div className="jumbotron-container">
        <div className="jumbotron jumbotron-fluid">
          <div className="container">
            <h1 className="display-4">Budget-Pal</h1>
            <p className="lead">A budget tracking application.</p>
          </div>
        </div>
      </div>

    );
  }
}

export default Home;
